import { createTheme } from "@mui/material/styles";

const Theme = createTheme({
  palette: {
    mode: "dark", // Or 'light' for light theme
    primary: {
      main: "#84D2EF",
      dark: "#59C0E8",
      light: "#3DB4E5",
    },
    secondary: {
      main: "#FFFFFF",
    },
    text: {
      primary: "#FFFFFF",
      secondary: "#FFFFFFB3",
      disabled: "#FFFFFF61",
      yellow: "#FFC107",
    },
    background: {
      primary: "#313131",
    },
    success: {
      main: "#81C784",
    },
    error: {
      main: "#F44336",
    },
    warning: {
      main: "#FFA726",
    },
    info: {
      main: "#29B6F6",
    },
    custom: {
      main: "#FFC107",
    },
    action: {
      hover: "rgba(61, 180, 229, 0.08)",
      selected: "rgba(61, 180, 229, 0.16)",
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          textTransform: "none",
          fontWeight: "500",
          fontSize: "15px",
        },
        containedPrimary: {
          backgroundColor: "#84D2EF",
          "&:hover": {
            backgroundColor: "#59C0E8",
          },
          "&.Mui-disabled": {
            backgroundColor: "#9E9E9E",
          },
        },
        containedSecondary: {
          backgroundColor: "#FFFFFF",
          color: "#3DB4E5",
          "&:hover": {
            backgroundColor: "#3DB4E5",
            color: "#FFFFFF",
          },
        },
      },
    },
    MuiCheckbox: {
      styleOverrides: {
        root: {
          color: "#84D2EF",
          "&.Mui-checked": {
            color: "#59C0E8",
          },
        },
      },
    },
    MuiSwitch: {
      styleOverrides: {
        thumb: {
          backgroundColor: "#84D2EF",
        },
        track: {
          backgroundColor: "#3DB4E5",
          opacity: 0.5,
        },
      },
    },
    MuiRadio: {
      styleOverrides: {
        root: {
          color: "#84D2EF",
          "&.Mui-checked": {
            color: "#59C0E8",
          },
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        icon: {
          color: "#84D2EF",
        },
        outlined: {
          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: "#84D2EF",
          },
        },
      },
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          color: "#FFFFFF",
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          "& input:-webkit-autofill": {
            boxShadow: "0 0 0 100px #2f2f2f inset !important",
            backgroundColor: "inherit !important",
            WebkitTextFillColor: "white !important",
          },
        },
      },
    },
  },
  typography: {
    fontFamily: "Roboto",
    fontSize: 16,
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightMedium: 500,
    fontWeightBold: 700,
    h1: {
      fontSize: "96px",
    },
    h2: {
      fontSize: "60px",
    },
    h3: {
      fontSize: "48px",
    },
    h4: {
      fontSize: "34px",
    },
    h5: {
      fontSize: "24px",
    },
    h6: {
      fontSize: "20px",
    },
    subtitle1: {
      fontSize: "16px",
    },
    subtitle2: {
      fontSize: "14px",
    },
    body1: {
      fontSize: "16px",
    },
    body2: {
      fontSize: "14px",
    },
    caption: {
      fontSize: "12px",
    },
    overline: {
      fontSize: "12px",
      fontWeight: "bold",
      textTransform: "uppercase",
    },
  },
});

export default Theme;
